export default __webpack_public_path__ + "static/Montreal-3b98ded65bb69db3a02bdc2b86193574.png";